export default function ({ store }) {
  store.commit("profiles/resetFilters");
}
